import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerFilterModel, CustomerModel, CustomerServiceProxy, QueryModel, SortOrder } from '../../../shared/service-proxies/event-service-proxy';

@Injectable({
  providedIn: 'root',
})
export class CustomerHelperService {
  constructor(private _customerService: CustomerServiceProxy) {}

  getCustomers(filter: CustomerFilterModel): Observable<CustomerModel[]> {
    return this._customerService.getByFilter(filter).pipe(
      map((res) =>
        res.items
          .map((c) =>
           Object.assign(new CustomerModel(), c, {
            custom: [c.firstname, c.lastname].filter(Boolean).join(' ') || 'Без имени',
          })
          )
      )
    );
  }

  filterCustomersByQuery(customers: CustomerModel[], searchText: string): { customer: CustomerModel; matches: Record<string, string> }[] {
    if (!searchText.trim()) {
      return [];
    }

    const query = searchText.toLowerCase();

    const filteredCustomers = customers
      .map((customer) => {
        const matches: Record<string, string> = {};

        Object.entries(customer).forEach(([key, value]) => {
          if (typeof value === 'string' && value.toLowerCase().includes(query)) {
            matches[key] = value; 
            matches['custom'] = query;
          }
        });

        return Object.keys(matches).length > 0 ? { customer, matches } : null;
      })
      .filter(Boolean) as { customer: CustomerModel; matches: Record<string, string> }[];

    console.log('🔍 Знайдені співпадіння:', filteredCustomers);
    return filteredCustomers;
  }

  searchCustomers(searchText: string, pageSize: number): Observable<{ customer: CustomerModel; matches: Record<string, string> }[]> {
    const searchModel = new QueryModel();
    searchModel.query = searchText;
    searchModel.page = 1;
    searchModel.perPage = pageSize;
    searchModel.sortOrder = SortOrder.Desc;
    searchModel.sortBy = 'createdAt';

    return this._customerService.search(searchModel).pipe(
      map((res) =>
        this.filterCustomersByQuery(
          res.items.map((c) =>
            Object.assign(new CustomerModel(), c, {
              custom: [c.firstname, c.lastname].filter(Boolean).join(' ') || 'Без имени',
            })
          ),
          searchText
        )
      )
    );
  }

  getCustomerDetails(customerId: string): Observable<CustomerModel> {
    return this._customerService.getDetails(customerId);
  }
}
